var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number || _vm.number == 0)?_c('div',{staticClass:"shadow-lg h-full rounded-xl flex flex-col justify-center items-center",class:_vm.boxClass},[_c('p',{staticClass:"text-gray-100 mb-0 font-semibold text-lg"},[_vm._v(_vm._s(_vm.content))]),_c('p',{staticClass:"text-2xl font-semibold text-gray-100 mb-0"},[_vm._v(_vm._s(_vm.number))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }